import React from 'react';
import Header from '../Header';
import './styles.css';

const Layout = ({ children }) => (
  <div className="layout">
    <Header />
    <div className="layout__content">{children}</div>
  </div>
);

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout/index.js